import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroContasPagar } from '@/features/relatorio/page/financeiro/contas-pagar/RelatorioFinanceiroContasPagar';

export const Route = createFileRoute('/a/relatorio/financeiro/contas-pagar')({
    component: RelatorioFinanceiroContasPagar,
});
